import '../../App.css';
import React, { useContext, useState, useEffect } from "react";
import { ApiContext } from "../../context/ApiContext";
import { Form, Row, Col, Table } from 'react-bootstrap';
import { FaTimes } from 'react-icons/fa';
import SelectMultiplo from '../SelectMultiplo';
import Cookies from 'js-cookie'
import { StyleContext } from '../../context/StyleContext';
import { PermissoesContext } from '../../context/PermissoesContext';

function ModalCadastrarUsuario({ closeModal }) {
    const { CadastrarUsuario, CadastroUsuario, setCadastroUsuario, Areas, ListaArea } = useContext(ApiContext)
    const { Menu } = useContext(PermissoesContext)
    const { btnVer, btnCriar } = useContext(StyleContext)
    const role = Cookies.get('Role')
    const [permissoes, setPermissoes] = useState([])

    const handleChange = (event) => {
        if (event.target.name === "admin") {
            setCadastroUsuario({ ...CadastroUsuario, [event.target.name]: event.target.checked })
        } else {
            setCadastroUsuario({ ...CadastroUsuario, [event.target.name]: event.target.value })
        }
    }

    const permissaoHandleChange = (menuKey, tipo) => {
        setPermissoes((prev) => {
            return prev.map((perm) => {
                if (perm.menuKey !== menuKey) return perm;

                if (tipo === "edicao") {
                    const novaEdicao = !perm.edicao;
                    return {
                        ...perm,
                        edicao: novaEdicao,
                        somenteLeitura: novaEdicao ? true : perm.somenteLeitura
                    };
                }

                if (tipo === "somenteLeitura") {
                    if (perm.edicao) {
                        return perm;
                    }
                    return {
                        ...perm,
                        somenteLeitura: !perm.somenteLeitura
                    };
                }

                return perm;
            });
        });
    };

    useEffect(() => {
        setPermissoes(Menu.map((item) => ({
            usuarioId: "",
            menuKey: item.key,
            edicao: false,
            somenteLeitura: false,
        })));
    }, [Menu]);

    useEffect(() => {
        setCadastroUsuario((prev) => ({
            ...prev,
            permissoes: permissoes,
        }));
    }, [permissoes]);

    const handleSubmit = async (event) => {
        event.preventDefault();

        setCadastroUsuario((prev) => ({
            ...prev,
            permissoes: permissoes,
        }));

        await CadastrarUsuario({
            ...CadastroUsuario,
            permissoes,
        });
    };

    useEffect(() => {
        ListaArea()
    }, [])

    const [areasSelecionadas, setAreasSelecionadas] = useState([]);

    const areasOptions = (Areas || []).map((org) => ({
        label: org.descricao,
        value: org.key,
    }));

    const handleAreasChange = (selectedOptions) => {
        setAreasSelecionadas(selectedOptions);

        const areasKeys = selectedOptions.map((org) => ({
            areaKey: org.value,
        }));

        setCadastroUsuario((prev) => ({
            ...prev,
            areas: areasKeys,
        }));
    };

    return (
        <div className="modal-novo">
            <div className="modal-novo-interno">
                <div className="header-modal">
                    <h1 className="h1-modal">Cadastrar usuário</h1>
                    <div className="btn-close-modal" onClick={() => closeModal(false)}>
                        <FaTimes />
                    </div>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="modal-content">
                        <Row>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Nome</Form.Label>
                                    <Form.Control onChange={handleChange} name="nome" />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>E-mail</Form.Label>
                                    <Form.Control type="email" onChange={handleChange} name="email" />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Áreas</Form.Label>
                                    <SelectMultiplo
                                        options={areasOptions}
                                        value={areasSelecionadas}
                                        onChange={handleAreasChange}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Form.Group className="mb-1">
                            <Form.Label>Função</Form.Label>
                            {['checkbox'].map((type, index) => (
                                <div key={index} className="mb-3">
                                    {role == "admin" &&
                                        <Form.Check
                                            inline
                                            label="Administrador de usuários"
                                            name="admin"
                                            type={type}
                                            id={`inline-${type}-2`}
                                            onChange={handleChange}
                                        />
                                    }
                                </div>
                            ))}
                        </Form.Group>
                        <div>
                            <Table bordered size="sm" className="align-middle titulo-fases" style={{ width: "50%" }}>
                                <thead>
                                    <tr>
                                        <th className="text-start"></th>
                                        <th>Edição</th>
                                        <th>Leitura</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Menu.map((item, index) => {
                                        const permissao = permissoes.find((p) => p.menuKey === item.key) || {};
                                        return (
                                            <tr key={index}>
                                                <td className="text-start">{item.descricao}</td>
                                                <td style={{ textAlign: "center" }}>
                                                    <Form.Check
                                                        type="checkbox"
                                                        checked={!!permissao.edicao}
                                                        onChange={() => permissaoHandleChange(item.key, "edicao")}
                                                        className="m-0"
                                                    />
                                                </td>
                                                <td style={{ textAlign: "center" }}>
                                                    <Form.Check
                                                        type="checkbox"
                                                        checked={!!permissao.somenteLeitura}
                                                        onChange={() => permissaoHandleChange(item.key, "somenteLeitura")}
                                                        disabled={!!permissao.edicao}
                                                        className="m-0"
                                                    />
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </Table>

                        </div>
                    </div>
                    <div className="footer-modal-criar-demanda">
                        <button type="button" className="btn-dash btn-ver" style={btnVer} onClick={() => closeModal(false)}>Cancelar</button>
                        <button type="submit" className="btn-dash btn-criar" style={btnCriar}>Salvar</button>
                    </div>
                </form>
            </div >
        </div >
    )
}

export default ModalCadastrarUsuario